export default __webpack_public_path__ + "static/acbr-66da2d841448cc5f5cfe5645fbb8bf8f.png";